import React, { useEffect, memo } from "react";
import { connect } from "react-redux";
import { Container, Row } from "reactstrap";
import IssuerDomainMappingTable from "./components/IssuerDomainMappingTable";
import PageHeader from "../../../shared/components/PageHeader";
import { getAllIssuerDomainMappings } from "../actions/issuerDomainMap.actions";

const IssuerDomainMappingList = memo(({ dispatch, mappings }) => {
  const loadMappings = requestParams => {
    dispatch(getAllIssuerDomainMappings(requestParams));
  };
 const getIssuersMappingALL=()=>{
  dispatch(getAllIssuerDomainMappings({ page: 1, pageSize: 10 }));
 }
  useEffect(() => {
    dispatch(getAllIssuerDomainMappings({ page: 1, pageSize: 10 }));
  }, [dispatch]);

  return (
    <Container>
      <PageHeader
        header="Manage Issuer Domain Mapping"
        subheader="Manage issuer to domain mappings"
      />
      <Row>
        <IssuerDomainMappingTable
          dataState={mappings}
          fetchData={loadMappings}
          getIssuersMappingALL={getIssuersMappingALL}
        />
      </Row>
    </Container>
  );
});

export default connect(state => ({
  mappings: state.getAllIssuerDomainMapping
}))(IssuerDomainMappingList);
